
const DifferenceTag = ({ value }) => {
    if (value > 0) {
        return <span className="text-green-600 text-sm ml-2 bg-green-100 px-2 py-0.5 rounded">
            {value}% below average
        </span >
    }

    return null;

};

export default DifferenceTag;